export const supportLinks = {
  USER: 'https://meetings-eu1.hubspot.com/michela-valsecchi/user-onboarding',
  EXPLORER: 'https://meetings-eu1.hubspot.com/michela-valsecchi/explorer',
  'INVESTOR_&_PRIVATE':
    'https://meetings-eu1.hubspot.com/michela-valsecchi/private-investor'
};

const supportNumber = '+393780665970';
export const supportDirectContact = {
  WA_MOBILE: '+39 378 066 5970',
  WA_LINK: `https://wa.me/${supportNumber}`
};
